import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams, Loading, LoadingController, AlertController } from "ionic-angular";
import { LoginService } from "./login.service";
import { Storage } from "@ionic/storage";
import { HomePage } from "../home/home";

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  public userName: string = "";
  public password: string = "";
  public loading: Loading;

  constructor(
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private loginService: LoginService,
    private storage: Storage,
    private navParams: NavParams) {
  }

  userLogin(){
    this.showLoading();
    this.loginService.callLoginApi(this.userName, this.password).subscribe(
      (data) => {
        this.storage.set('username', this.userName);
        this.loginService.storeAuthToken(data.access_token);
        this.navCtrl.setRoot(HomePage);
      },
       (error) => {this.showError(error.message)});
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...',
      dismissOnPageChange: true
    });
    this.loading.present();
  }

  showError(text) {
    this.loading.dismiss();
    let alert = this.alertCtrl.create({
      title: text,
      buttons: ['OK']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts